




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { employeeAdminApis, NewMailAccount } from '@/api/employee_admin.api';
import { InvalidParam } from '@/api/api_error';
@Component
export default class NewMailAccountDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;

  formData: NewMailAccount = {
    username: '',
    display_name: '',
    remark: '',
    mobile_phone_no: ''
  };
  errors: Record<string, string> = {};

  loading = false;

  rules = {
    username: [{ required: true, message: '请输入用户名(不带邮箱)', trigger: 'blur' }],
    display_name: [{ required: true, message: '请输入显示名称', trigger: 'blur' }],
    remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
  };

  get visible() {
    return this.value;
  }

  set visible(val: boolean) {
    this.$emit('input', val);
  }

  handleClose() {
    this.visible = false;
    this.resetForm();
  }

  resetForm() {
    this.formData = {
      username: '',
      display_name: '',
      remark: '',
      mobile_phone_no: ''
    };
    (this.$refs.form as any)?.resetFields();
  }

  async handleSubmit() {
    const valid = await (this.$refs.form as any).validate();
    if (!valid) return;

    this.errors = {};
    try {
      this.loading = true;
      await employeeAdminApis.newMailAccount(this.formData);
      this.$message.success('新建邮件账户成功');
      this.$emit('refresh');
      this.handleClose();
    } catch (error) {
      if (error instanceof InvalidParam) {
        this.errors = error.params;
      }
      this.$message.error('新建邮件账户失败：' + (error as any).message);
    } finally {
      this.loading = false;
    }
  }
}
